import { useEffect, useState, useRef, } from "react";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import {
    getMapLocations,
    // stateStatusOrderedRide
} from "../../Store/Actions/user";
// import { approvalNegoTrxRide, } from "../../Store/Actions/booking";
// import { useNavigate } from "react-router-dom";

import { MapContainer, TileLayer, Marker, Polyline, Tooltip, useMapEvent } from "react-leaflet";
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import { getIconByType, MyIconDestination, MyIconPickup, } from "../../Constants/mapAttribute";
import env from "../../Confgs/vars";
import { isEmpty } from "../../Utils/string";
// import calculateFare from "../../Utils/calculateFare";
import Spinner from "../../Components/Spinner";
import { AppDispatch } from "../../Store/Reducers";
import SearchBar from "../../Components/SearchBar";

const OrderDriver = () => {
    const dispatch: AppDispatch = useDispatch();
    // const navigate = useNavigate();

    const mapRef = useRef<L.Map | null>(null);
    const markerRef = useRef<L.Marker<any> | null>(null);

    const { stateOrderDriver, } = useSelector((state: any) => state.auth);
    // const {
    //     dataCalculateDistance, 
    //     dataIdOrderedRide,
    // } = useSelector((state: any) => state.userReducer);
    const {
        // stateOrderDriverPickup, 
        dataStateCoordinateCustomer } = useSelector((state: any) => state.bookingReducer)

    // const distanceCustomerToDestination = dataCalculateDistance?.distance;
    // const distanceKM = Math.ceil(distanceCustomerToDestination / 1000);
    // const baseFare = calculateFare(distanceKM);

    const [positions, setPositions] = useState({
        currentPosition: null,
        senderPositions: null,
        recipientPosition: null,
        polylinePositions: [],
        selectedPosition: null,
    });

    const { polylinePositions, senderPositions, recipientPosition } = positions;
    const [pickup, setPickup] = useState<{ lat: number; lng: number, label: string }>({ lat: 0, lng: 0, label: "" });
    const [destination, setDestination] = useState<{ lat: number; lng: number, label: string }>({ lat: 0, lng: 0, label: "" });

    const [pickupSearch, setPickupSearch] = useState<{ lat: number; lng: number, label: string }>({ lat: 0, lng: 0, label: "" });
    const [destinationSearch, setDestinationSearch] = useState<L.LatLng | { lat: number; lng: number, label: string }>({ lat: 0, lng: 0, label: "" });

    const [editing, setEditing] = useState("pickup");
    const [, setEditingType] = useState("ride");
    // const [, setLoadingWaiting] = useState(false);
    const [, setDataOrderRide] = useState<any[]>([]);

    useEffect(() => {
        document.addEventListener('message', (event: any) => {
            const receivedData = JSON.parse(event.data);
            if (receivedData.type === 'CHOICED_PAYLOAD') {
                setEditing(receivedData?.payload?.editing);
                setEditingType(receivedData?.payload?.editingType);
            }
            if (receivedData.type === 'ORDERED_PAYLOAD') {
                setDataOrderRide(receivedData?.payload?.dataOrderRide);
            }
        });
    }, []);

    useEffect(() => {
        if (window.ReactNativeWebView?.postMessage) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    type: `POSITIONS_DATA`,
                    payload: positions,
                })
            );
        }
    }, [positions]);

    // const initialState = {
    //     message: "",
    //     phone: "",
    //     usePhoneOption: 'manual',
    // };

    // const [form, setForm] = useState(initialState);
    // const [openModal, setOpenModal] = useState(false);

    const MapClickHandler = ({ onClick }: { onClick: (event: any) => void }) => {
        useMapEvent('click', onClick);
        return null;
    };

    // const handleSubmit = async (e: any) => {
    //     e.preventDefault();
    //     const payload = {
    //         user_id_driver: stateOrderDriver?.users_id,
    //         pickup_point: !isEmpty(senderPositions) ? `${senderPositions?.[0]},${senderPositions?.[1]}` : [],
    //         destination: !isEmpty(recipientPosition) ? `${recipientPosition?.[0]},${recipientPosition?.[1]}` : [],
    //         ride_type: editingType,
    //         message: form?.message,
    //         phone: form?.phone,
    //     };

    //     if (payload?.pickup_point.length <= 0) {
    //         return toast.error("Anda belum menentukan titik Jemput", {
    //             // autoClose: 700,
    //             position: "bottom-center",
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //         });
    //     }
    //     if (payload?.destination.length <= 0) {
    //         return toast.error("Anda belum menentukan titik tujuan", {
    //             // autoClose: 700,
    //             position: "bottom-center",
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //         });
    //     }
    //     if (!payload?.phone) {
    //         return toast.error("Masukkan no WA Anda", {
    //             // autoClose: 700,
    //             position: "bottom-center",
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //         });
    //     }
    //     if (!payload?.message) {
    //         return toast.error("Isi tinggalkan pesan", {
    //             // autoClose: 700,
    //             position: "bottom-center",
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //         });
    //     }

    //     setLoadingWaiting(true);
    //     try {
    //         const res: any = await dispatch(createTrxRide(payload));

    //         if (res?.success) dispatch(stateIdOrderedRide(res.data.id));
    //     } catch (error: any) {
    //         setLoadingWaiting(false);
    //     }

    // };

    // const handleAccept = async (e: any) => {
    //     setOpenModal(false)
    //     e.preventDefault();
    //     const payload = {
    //         id: dataIdOrderedRide,
    //         approval: "Terima",
    //     };

    //     try {
    //         const res: any = await dispatch(approvalNegoTrxRide(payload));
    //         if (res?.success) {
    //             dispatch(stateStatusOrderedRide(null));
    //             setLoadingWaiting(false);
    //             navigate("/orderDriverTrace");
    //         }
    //     } catch (error) {
    //         setLoadingWaiting(false);
    //     }
    // };

    // const handleReject = async (e: any) => {
    //     setOpenModal(false)
    //     e.preventDefault();
    //     const payload = {
    //         id: dataIdOrderedRide,
    //         approval: "Tolak",
    //     };

    //     try {
    //         const res: any = await dispatch(approvalNegoTrxRide(payload));
    //         if (res?.success) {
    //             setLoadingWaiting(false);
    //             navigate(`/mobile/nearestDrivers/tokenPath/${stateOrderDriverPickup?.access_token}/refreshToken/${stateOrderDriverPickup?.refresh_token}/userId/${stateOrderDriverPickup?.user?.id}`);
    //         }
    //     } catch (error) {

    //     }
    // }

    useEffect(() => {
        const watchId = navigator.geolocation.watchPosition(
            async (position) => {
                const { latitude, longitude } = position.coords;
                setPositions((prevPositions: any) => ({
                    ...prevPositions,
                    currentPosition: [latitude, longitude],
                }));
                //   dispatch(stateLocation([latitude, longitude]));
            },
            (err) => console.log(err),
            { enableHighAccuracy: true }
        );

        return () => navigator.geolocation.clearWatch(watchId);
    }, []);


    // Untuk inisialisasi pickup hanya sekali saat pertama kali mendapat posisi current
    useEffect(() => {
        if (dataStateCoordinateCustomer && !pickup?.label) {
            setPickup({ lat: dataStateCoordinateCustomer?.latitude, lng: dataStateCoordinateCustomer?.longitude, label: "First Positions" });
        }
    }, [dataStateCoordinateCustomer, pickup]);


    useEffect(() => {
        if (pickup?.lat && pickup?.lng) {
            (async () => {
                setPositions((prevPositions: any) => ({
                    ...prevPositions,
                    senderPositions: [pickup?.lat, pickup?.lng],
                }));
            })();
        }
        if (destination?.lat && destination?.lng) {
            (async () => {
                setPositions((prevPositions: any) => ({
                    ...prevPositions,
                    recipientPosition: [destination?.lat, destination?.lng],
                }));
            })();
        }
    }, [pickup, destination,]);

    const editingRef = useRef(editing);

    useEffect(() => {
        editingRef.current = editing;
    }, [editing]);


    useEffect(() => {
        if (pickupSearch?.lat && pickupSearch?.lng) {
            (async () => {
                setPositions((prevPositions: any) => ({
                    ...prevPositions,
                    senderPositions: [pickupSearch?.lat, pickupSearch?.lng],
                }));
            })();
        }
        if (destinationSearch?.lat && destinationSearch?.lng) {
            (async () => {
                setPositions((prevPositions: any) => ({
                    ...prevPositions,
                    recipientPosition: [destinationSearch?.lat, destinationSearch?.lng],
                }));
            })();
        }
    }, [pickupSearch, destinationSearch,]);

    const handleMapClick = (e: any) => {
        const { lat, lng }: any = e.latlng;
        if (editing === "pickup") {
            setPickup({ lat, lng: lng, label: "Custom Pickup" });
            setPickupSearch({ lat: 0, lng: 0, label: "" });
        } else {
            setDestination({ lat, lng: lng, label: "Custom Destination" });
            setDestinationSearch({ lat: 0, lng: 0, label: "" });
        }
    };

    type MapLocation = {
        id: string;
        name: string;
        latitude: number;
        longitude: number;
    };

    const [zoom, setZoom] = useState(16);
    const [localMapData, setLocalMapData] = useState<MapLocation[]>([]);
    const zoomCache = useRef<{ [key: number]: any[] }>({});
    const [mapReady, setMapReady] = useState(false);

    const onMapReady = (mapInstance: L.Map) => {
        mapRef.current = mapInstance;
        setMapReady(true);
    };

    useEffect(() => {
        if (!mapReady || !mapRef.current) return;

        const mapInstance = mapRef.current;

        const handleZoom = async () => {
            const zoomLevel = mapInstance.getZoom();
            setZoom(zoomLevel);

            if (zoomLevel >= 18) {
                if (zoomCache.current[18]) {
                    setLocalMapData([
                        ...(zoomCache.current[17] || []),
                        ...zoomCache.current[18],
                    ]);
                } else {
                    const res = await dispatch(getMapLocations({ page: 2, limit: env.mapLimit }));
                    const data = (res as any) || [];
                    zoomCache.current[18] = data;
                    setLocalMapData([
                        ...(zoomCache.current[17] || []),
                        ...data,
                    ]);
                }
            } else if (zoomLevel === 17) {
                if (zoomCache.current[17]) {
                    setLocalMapData(zoomCache.current[17]);
                } else {
                    const res = await dispatch(getMapLocations({ page: 1, limit: env.mapLimit }));
                    const data = (res as any) || [];
                    zoomCache.current[17] = data;
                    setLocalMapData(data);
                }
            } else {
                setLocalMapData([]);
            }
        };

        mapInstance.on('zoomend', handleZoom);

        return () => {
            mapInstance.off('zoomend', handleZoom);
        };
    }, [dispatch, mapReady]);


    const [mapTile, setMapTile] = useState("osm");
    const [maxZoomState,] = useState(21);


    const handleChangeDistance = (event: any) => {
        setMapTile(event.target.value);
    };

    return (
        <>
            {
                <>
                    <div className="p-0 rounded-none">
                        {/* popup nego dari driver */}
                        {/* {openModal && (
                            <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40">
                                <div className="bg-white p-4 w-full max-w-md mx-auto rounded-lg shadow-lg flex flex-col gap-2">
                                    <h6 className="text-center font-bold text-lg">
                                        Notifikasi Negosiasi
                                    </h6>
                                    <p className="text-sm">
                                        <strong>
                                            Driver mengajukan tarif menjadi {convertToRupiah(dataOrderRide?.[0]?.base_fare_negotiations)}
                                        </strong>
                                    </p>
                                    <p className="text-sm">
                                        <strong>Alasan : {dataOrderRide?.[0]?.remark}</strong>
                                    </p>

                                    <div className="flex justify-center gap-10 mt-4">
                                        <button
                                            onClick={handleReject}
                                            className="px-4 py-2 bg-red-100 text-red-600 border border-red-300 rounded-md hover:bg-red-200 hover:text-red-700 transition-all duration-200"
                                        >
                                            Tolak
                                        </button>
                                        <button
                                            onClick={handleAccept}
                                            className="px-4 py-2 bg-green-100 text-green-600 border border-green-300 rounded-md hover:bg-green-200 hover:text-green-700 transition-all duration-200"
                                        >
                                            Terima
                                        </button>
                                    </div>

                                </div>
                            </div>
                        )} */}
                    </div>


                    {isEmpty(dataStateCoordinateCustomer) ? (
                        <Spinner />
                    ) : (
                        <>
                            {/* Map */}
                            <div className="bg-white rounded shadow p-0">
                                <div className="w-full md:w-full">

                                    <MapContainer
                                        ref={(mapInstance: L.Map) => {
                                            if (mapInstance && !mapRef.current) {
                                                mapRef.current = mapInstance;
                                                onMapReady(mapInstance);
                                            }
                                        }}
                                        center={dataStateCoordinateCustomer ? [dataStateCoordinateCustomer?.latitude, dataStateCoordinateCustomer?.longitude] : [stateOrderDriver?.latitude, stateOrderDriver?.longitude]}
                                        zoom={zoom ? zoom : 16}
                                        maxZoom={maxZoomState}
                                        zoomControl={false}
                                        style={{ height: "100vh", width: "auto" }}
                                        attributionControl={false}
                                    >
                                        <MapClickHandler onClick={handleMapClick} />


                                        {mapTile === "osm" ? (
                                            <TileLayer
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                maxZoom={21}
                                            />
                                        ) : (
                                            <TileLayer
                                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                                // attribution='Tiles &copy; Esri'
                                                maxZoom={18}
                                            />
                                        )}

                                        <SearchBar
                                            onSelect={(result) => {
                                                const { lat, lon, label } = result;
                                                const currentEditing = editingRef.current;
                                                if (currentEditing === "pickup") {
                                                    setPickupSearch({ lat, lng: lon, label });
                                                } else {
                                                    setDestinationSearch({ lat, lng: lon, label });
                                                }
                                            }}
                                        />

                                        {/* Marker lokasi */}
                                        {localMapData.length > 0 && localMapData?.map((loc: any, index: number) => (
                                            <Marker
                                                key={index}
                                                position={[loc?.latitude, loc?.longitude]}
                                                icon={getIconByType(loc?.type)}
                                            >
                                                <Tooltip
                                                    direction="bottom"
                                                    offset={[0, 20]}
                                                    opacity={1}
                                                    permanent
                                                    className="custom-tooltip"
                                                >
                                                    {loc?.name}
                                                </Tooltip>
                                            </Marker>
                                        ))}

                                        {senderPositions && (
                                            <Marker
                                                ref={markerRef} position={senderPositions} icon={MyIconPickup}>
                                            </Marker>
                                        )}

                                        {recipientPosition && (
                                            <Marker
                                                ref={markerRef} position={recipientPosition} icon={MyIconDestination}>
                                            </Marker>
                                        )}

                                        {polylinePositions.length > 0 && <Polyline positions={polylinePositions} />}

                                        {/* Marker Search */}
                                        {/* {pickupSearch && (
                                            <Marker
                                                position={[pickupSearch.lat, pickupSearch.lng]}
                                                icon={getIconByType("search")}
                                            >
                                            </Marker>
                                        )}

                                        {destinationSearch && (
                                            <Marker
                                                position={[destinationSearch.lat, destinationSearch.lng]}
                                                icon={getIconByType("destination")}
                                            >
                                            </Marker>
                                        )} */}

                                    </MapContainer>
                                    <div className="absolute top-12 left-2.5 z-[1000] bg-white rounded-xl shadow-md p-0">
                                        <select
                                            value={mapTile}
                                            onChange={handleChangeDistance}
                                            className="text-sm px-0 py-0 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <option value="osm">Default</option>
                                            <option value="satelite">Satelit</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* form */}

                            {/* <div className="absolute bottom-0 left-2.5 z-[1000]">
                                <div className="ml-0">
                                    <button
                                        onClick={() =>
                                            navigate(
                                                `/mobile/nearestDrivers`
                                            )
                                        }
                                        className="flex items-center text-sm text-[#2580d6] border border-[#3A82F7] bg-[#FFFFFF] px-3 py-1 rounded hover:bg-[#f0f8ff]"
                                    >
                                        Kembali
                                    </button>
                                </div>
                            </div> */}

                        </>
                    )}
                </>
            }
        </ >
    );
};

export default OrderDriver;
